export var isCustomUI = function isCustomUI(extension, entryPoint) {
  var _extension$properties = extension.properties,
    render = _extension$properties.render,
    resource = _extension$properties.resource;
  if (entryPoint && extension.properties[entryPoint]) {
    var _extension$properties2 = extension.properties[entryPoint],
      entryPointResource = _extension$properties2.resource,
      entryPointRender = _extension$properties2.render;
    return entryPointResource != null && entryPointRender !== 'native';
  }
  return resource != null && render !== 'native';
};